import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpoints } from 'frontend/js/modules/infra/dls/hooks/use-get-breakpoints';
import { getViewerIdAndKind, useSession } from 'frontend/js/modules/infra/session';
import { useApiMutation } from 'frontend/js/modules/infra/api';
import { t } from 'frontend/js/modules/infra/i18n';
import { showNotification } from 'frontend/js/app/common/helpers/notifications';
import { AutomatedListView } from './automated-list-view';
import { useAutomatedTable } from './table/use-automated-table';
import { endpoints } from '../../network';
export var AutomatedListViewContainer = function () {
    var _a = useAutomatedTable(), table = _a.table, isLoading = _a.isLoading, onRowClick = _a.onRowClick, allCampaignsTurnedOn = _a.allCampaignsTurnedOn;
    var isTabletOrSmaller = useBreakpoints().isTabletOrSmaller;
    var session = useSession().data;
    var _b = getViewerIdAndKind(session), id = _b.id, kind = _b.kind;
    var _c = useApiMutation({
        endpoint: endpoints.bulkToggleAutomatedCampaignsMutation,
        options: {
            onSuccess: function () {
                showNotification({
                    title: '',
                    message: t('engage:notifications.automated_campaigns_activated'),
                    autoDismiss: 8,
                });
            },
        },
    }), toggleAutomatedCampaigns = _c.mutate, toggleAutomatedCampaignsLoading = _c.isLoading;
    var handleTurnOnAllCampaigns = function () {
        toggleAutomatedCampaigns({ ownerId: id, ownerType: kind, isEnabled: true });
    };
    return (_jsx(AutomatedListView, { table: table, isLoading: isLoading, isTabletOrSmaller: isTabletOrSmaller, handleTurnOnAllCampaigns: handleTurnOnAllCampaigns, onRowClick: onRowClick, toggleAutomatedCampaignsLoading: toggleAutomatedCampaignsLoading, allCampaignsTurnedOn: allCampaignsTurnedOn }));
};
